exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleCurve_125R4 {\n    text-decoration: underline;\n    font-weight: 800;\n}\n", ""]);

// exports
exports.locals = {
	"titleCurve": "titleCurve_125R4"
};